{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Η επέκταση Chrome δεν είναι εγκατεστημένη.",
      "CTA": "Εγκατάσταση επέκτασης"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Δεν υπάρχει σύνδεση με το τηλεφωνικό σύστημα",
      "MESSAGE": "Φαίνεται πως δεν έχετε σύνδεση στο διαδίκτυο. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.",
      "CREDENTIALS_TITLE": "Το τηλεφωνικό σύστημα απέρριψε τα διαπιστευτήριά σας",
      "CREDENTIALS_MESSAGE": "Το τηλεφωνικό σύστημα απέρριψε το όνομα χρήστη ή τον κωδικό πρόσβασης που είναι αποθηκευμένα στο προφίλ σας. Ελέγξτε τα στις Ρυθμίσεις Προφίλ ή απευθυνθείτε στον διαχειριστή σας.",
      "CONFIGURATION_TITLE": "Οι ρυθμίσεις τηλεφώνου δεν είναι έγκυρες",
      "CONFIGURATION_MESSAGE": "Το όνομα χρήστη SIP ή η διεύθυνση του διακομιστή δεν έχει έγκυρη μορφή, επομένως το τηλέφωνο δεν μπορεί να συνδεθεί. Διορθώστε το στις Ρυθμίσεις Προφίλ.",
      "NETWORK_SHORT": "Η σύνδεση απέτυχε",
      "CREDENTIALS_SHORT": "Τα διαπιστευτήρια απορρίφθηκαν",
      "CONFIGURATION_SHORT": "Μη έγκυρες ρυθμίσεις τηλεφώνου",
      "RETRY": "Δοκιμάστε ξανά",
      "DISMISS": "Άκυρο"
    },
    "CONNECTION_QUALITY": "Ποιότητα σύνδεσης",
    "CONNECTION_QUALITY_EXCELLENT": "Εξαιρετική",
    "CONNECTION_QUALITY_GOOD": "Καλή",
    "CONNECTION_QUALITY_FAIR": "Μέτρια",
    "CONNECTION_QUALITY_POOR": "Κακή",
    "CONNECTION_QUALITY_DISCONNECTED": "Αποσυνδεδεμένη",
    "TABS": {
      "PHONE": "Τηλέφωνο",
      "SMS": "SMS",
      "HISTORY": "Ιστορικό"
    },
    "HISTORY": {
      "OPEN": "Ανοιχτές",
      "RECENT": "Πρόσφατες",
      "MISSED": "Αναπάντητες",
      "LOADING": "Φόρτωση κλήσεων...",
      "EMPTY": "Δεν υπάρχουν κλήσεις εδώ",
      "ERROR": "Δεν ήταν δυνατή η φόρτωση των κλήσεων",
      "CALL": "Επανάκληση",
      "CALL_STATUS": {
        "BUTTON": "Ορισμός κατάστασης κλήσης",
        "TITLE": "Κατάσταση κλήσης",
        "SEARCH_PLACEHOLDER": "Αναζήτηση καταστάσεων...",
        "LOADING": "Φόρτωση καταστάσεων...",
        "NO_OPTIONS": "Δεν έχουν διαμορφωθεί καταστάσεις κλήσης",
        "NO_MATCH": "Δεν βρέθηκε αντίστοιχη κατάσταση",
        "OPTIONS_ERROR": "Δεν ήταν δυνατή η φόρτωση των καταστάσεων",
        "RETRY": "Δοκιμάστε ξανά",
        "CONFIRM_QUESTION": "Να οριστεί η κατάσταση «{status}» και να επιλυθεί η συνομιλία?",
        "CONFIRM": "Επιβεβαίωση",
        "BACK": "Πίσω",
        "CANCEL": "Άκυρο",
        "SAVING": "Αποθήκευση...",
        "SAVE_ERROR": "Δεν ήταν δυνατή η αποθήκευση της κατάστασης",
        "RESOLVE_ERROR": "Η κατάσταση αποθηκεύτηκε, αλλά δεν ήταν δυνατή η επίλυση της συνομιλίας"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Αριθμός τηλεφώνου, π.χ. +421903000000",
      "BODY_PLACEHOLDER": "Γράψτε το μήνυμά σας...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Αποστολή SMS",
      "SENDING": "Γίνεται αποστολή...",
      "SENT": "Το SMS στάλθηκε",
      "LOADING": "Φόρτωση κιβωτίων εισερχομένων SMS...",
      "NO_INBOX": "Αυτός ο λογαριασμός δεν έχει κιβώτιο εισερχομένων SMS, επομένως δεν είναι δυνατή η αποστολή SMS.",
      "INVALID_NUMBER": "Εισαγάγετε τον αριθμό σε διεθνή μορφή, μαζί με το αρχικό +.",
      "ERROR": "Δεν ήταν δυνατή η αποστολή του SMS. Δοκιμάστε ξανά."
    },
    "ACTIONS": {
      "CONNECT": "Σύνδεση",
      "GO_TO_TAB": "Μετάβαση σε αυτή την καρτέλα",
      "DISCONNECT": "Αποσύνδεση",
      "ANSWER": "Απάντηση",
      "HANGUP": "Τερματισμός",
      "HOLD": "Αναμονή",
      "MUTE": "Σίγαση μικροφώνου",
      "SILENCE": "Σίγαση ήχου",
      "TRANSFER": "Μεταφορά",
      "COMPLETE_TRANSFER": "Ολοκλήρωση μεταφοράς",
      "RETURN_TO_CALLER": "Επιστροφή στον καλούντα",
      "CANCEL_TRANSFER": "Ακύρωση μεταφοράς",
      "DIALPAD": "Εμφάνιση πληκτρολογίου",
      "OPEN_CONVERSATION": "Άνοιγμα συνομιλίας"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Εισερχόμενη κλήση",
      "INCOMING_CALL_FROM": "Εισερχόμενη κλήση από {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Εισερχόμενη κλήση από {number}",
      "ANSWER": "Απάντηση",
      "DECLINE": "Απόρριψη"
    },
    "TRANSFER": {
      "TITLE": "Μεταφορά κλήσης",
      "PLACEHOLDER": "Εισαγάγετε τον αριθμό προορισμού...",
      "SEARCH_PLACEHOLDER": "Αναζήτηση συναδέλφων...",
      "TARGET_PLACEHOLDER": "Επιλεγμένος προορισμός μεταφοράς",
      "CONFIRM": "Μεταφορά",
      "MODE_DIRECT": "Μεταφορά τώρα",
      "MODE_CONSULT": "Κλήση συναδέλφου πρώτα",
      "CANCEL": "Άκυρο"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Είστε βέβαιοι ότι θέλετε να κάνετε διάλειμμα σε όλες τις ουρές;",
      "CONFIRM_READY": "Είστε βέβαιοι ότι θέλετε να επιστρέψετε σε κατάσταση ετοιμότητας για όλες τις ουρές;",
      "CONFIRM_BREAK_QUEUE": "Είστε βέβαιοι ότι θέλετε να αποσυνδεθείτε από την ουρά {queue};",
      "CONFIRM_READY_QUEUE": "Είστε βέβαιοι ότι θέλετε να συνδεθείτε στην ουρά {queue};",
      "LOGIN_TO_QUEUE": "Σύνδεση",
      "LOGOUT_FROM_QUEUE": "Αποσύνδεση",
      "LOGIN_TO_ALL_QUEUES": "Σύνδεση σε όλες τις ουρές",
      "LOGOUT_FROM_ALL_QUEUES": "Αποσύνδεση από όλες τις ουρές",
      "OPTION_LOGOUT": "Αποσύνδεση",
      "OPTION_BREAK": "Διάλειμμα",
      "OPTION_LUNCH": "Μεσημεριανό",
      "OPTION_AWAY": "Απών",
      "OPTION_DO_NOT_DISTURB": "Μη ενόχληση",
      "OPTION_BUSINESS_TRIP": "Επαγγελματικό ταξίδι",
      "CONFIRM": "Επιβεβαίωση",
      "CANCEL": "Άκυρο"
    },
    "STATUS": {
      "OFFLINE": "Το τηλέφωνο είναι εκτός σύνδεσης",
      "IN_OTHER_TAB": "Το τηλέφωνο είναι συνδεδεμένο σε άλλη καρτέλα",
      "CONNECTING": "Σύνδεση...",
      "DISCONNECTING": "Αποσύνδεση...",
      "ONLINE": "Το τηλέφωνο είναι συνδεδεμένο",
      "DIALING": "Κλήση",
      "TRANSFERRING": "Μεταφορά...",
      "CONSULTING": "Συνομιλία με συνάδελφο",
      "CALLER_ON_HOLD": "Ο καλών είναι σε αναμονή",
      "BUSY": "Απασχολημένο",
      "DND": "DND",
      "UNAVAILABLE": "Μη διαθέσιμο",
      "REJECTED": "Η κλήση απορρίφθηκε",
      "CALL_FAILED": "Η κλήση απέτυχε"
    },
    "QUEUES": {
      "MORE": "Περισσότερες ουρές"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Κλήση {number}… Μπορείτε να κλείσετε αυτή την καρτέλα.",
    "NO_NUMBER": "Δεν δόθηκε αριθμός. Χρησιμοποιήστε ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Εισαγάγετε αριθμό τηλεφώνου...",
    "ACTIONS": {
      "DIAL": "Κλήση αριθμού",
      "DIAL_FROM": "Επιλέξτε τον αριθμό από τον οποίο καλείτε"
    },
    "DIAL_FROM": {
      "TITLE": "Κλήση από τον αριθμό εισερχομένων"
    },
    "VALIDATION": {
      "REQUIRED": "Ο αριθμός τηλεφώνου είναι υποχρεωτικός",
      "INVALID_FORMAT": "Μη έγκυρη μορφή αριθμού τηλεφώνου"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Ρυθμίσεις και δοκιμή ήχου",
    "SELECT_DEVICE": "Επιλέξτε συσκευή...",
    "SYSTEM_DEFAULT": "Προεπιλογή συστήματος",
    "SAVED": "Αποθηκεύτηκε",
    "DISCONNECTED_SUFFIX": "αποσυνδεδεμένο",
    "DEVICE_DISCONNECTED": "Η επιλεγμένη συσκευή δεν είναι συνδεδεμένη. Οι κλήσεις θα χρησιμοποιούν την προεπιλογή του συστήματος μέχρι να επανασυνδεθεί.",
    "MICROPHONE": {
      "TITLE": "Μικρόφωνο",
      "START_TEST": "Δοκιμή μικροφώνου",
      "STOP_TEST": "Διακοπή δοκιμής",
      "LEVEL": "Επίπεδο:",
      "VERDICT": {
        "LISTENING": "Πείτε κάτι στο μικρόφωνο…",
        "SILENT": "Δεν σας ακούει κανείς. Ελέγξτε ότι το μικρόφωνο είναι ενεργό και ότι έχει επιλεγεί το σωστό.",
        "LOW": "Σας ακούνε μόνο σιγανά. Επιλέξτε άλλο μικρόφωνο ή προσαρμόστε την ένταση εισόδου στις ρυθμίσεις του συστήματος.",
        "GOOD": "Καλός ήχος — σας ακούνε καθαρά."
      }
    },
    "SPEAKER": {
      "TITLE": "Ηχείο",
      "TEST": "Δοκιμή ηχείου",
      "TESTING": "Δοκιμή...",
      "VOLUME": "Ένταση:",
      "USING_DEFAULT": "Η επιλεγμένη έξοδος δεν είναι διαθέσιμη — αναπαράχθηκε στην προεπιλογή του συστήματος."
    },
    "DONE": "Τέλος",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Σφάλμα πρόσβασης στο μικρόφωνο. Ελέγξτε τα δικαιώματα.",
      "MICROPHONE_PERMISSION_DENIED": "Η πρόσβαση στο μικρόφωνο είναι αποκλεισμένη. Επιτρέψτε την στις ρυθμίσεις τοποθεσίας του προγράμματος περιήγησης για να χρησιμοποιήσετε το τηλέφωνο.",
      "MICROPHONE_SILENT": "Το μικρόφωνό σας δεν καταγράφει ήχο. Ελέγξτε τις ρυθμίσεις ήχου.",
      "EXTENSION_REQUIRED": "Δεν εντοπίστηκε η επέκταση τηλεφώνου. Εγκαταστήστε ή ενεργοποιήστε την για να χρησιμοποιήσετε το μικρόφωνο.",
      "SPEAKER_TEST": "Σφάλμα κατά τη δοκιμή εξόδου ηχείου."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Εκτός σύνδεσης",
    "ONLINE": "Συνδεδεμένος",
    "BUSY": "Απασχολημένος"
  },
  "QUEUE_STATUS": {
    "READY": "Έτοιμος",
    "NOT_READY": "Δεν δέχεται κλήσεις",
    "WRAP_UP": "Ολοκλήρωση κλήσης",
    "BREAK": "Διάλειμμα",
    "LUNCH": "Μεσημεριανό",
    "AWAY": "Απών",
    "DO_NOT_DISTURB": "Μη ενόχληση",
    "BUSINESS_TRIP": "Επαγγελματικό ταξίδι",
    "OTHER_CALL": "Άλλη κλήση",
    "QUEUE_CALL": "Κλήση ουράς",
    "OFFLINE": "Εκτός σύνδεσης",
    "ONLINE": "Συνδεδεμένος",
    "NO_ACCESS": "Χωρίς τηλέφωνο",
    "PARTIALLY_READY": "Μερικώς έτοιμος",
    "MIXED": "Μικτό",
    "CHAT_ONLINE": "Συνδεδεμένος (chat)",
    "CHAT_BUSY": "Απασχολημένος (chat)",
    "CHAT_OFFLINE": "Εκτός σύνδεσης (chat)"
  }
}
